import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { SectionTitle } from './SectionTitle';
import { painClosing, painPoints } from '../../data/artTherapy';
export function PainPoints() {
  return <section aria-labelledby="pain-title" className="bg-gradient-to-b from-lavender-soft to-[#F8EEFA] py-14 md:py-20" data-id="element-190" data-mp="1iayrywusftr3">
      <div className="mx-auto max-w-2xl px-5" data-id="element-191" data-mp="1dbvwo44m11wb">
        <SectionTitle id="pain-title" underline subtitle="Nem a motiváció hiányzik. Néha annyi minden nyomja a lelkedet, hogy már azt sem tudod, hogyan adj teret annak, amit érzel." data-id="element-192" data-mp="19b295bv2xp3y">
          Ismerős?
        </SectionTitle>

        <ul className="mt-9 space-y-4" data-id="element-193" data-mp="zdebad26g1hk">
          {painPoints.map((p, i) => <li key={i} className={`flex items-start gap-4 rounded-3xl border-l-4 bg-white px-5 py-5 shadow-[0_6px_20px_-12px_rgba(140,111,201,0.35)] sm:gap-5 sm:px-6 ${p.kind === 'no' ? 'border-no' : 'border-ok'}`} data-id="element-194" data-mp="ueuns87xqhn3" data-mpi={i}>
              {p.kind === 'no' ? <XIcon className="mt-1 h-6 w-6 shrink-0 text-[#F0567A]" strokeWidth={3} aria-hidden="true" data-id="element-195" data-mp="1ld0scjmsub4h" /> : <CheckIcon className="mt-1 h-6 w-6 shrink-0 text-ok" strokeWidth={3} aria-hidden="true" data-id="element-196" data-mp="1bg5v0429igrs" />}
              <p className="text-[17px] leading-relaxed text-body" data-id="element-197" data-mp="1gefnu80il5a8">{p.text}</p>
            </li>)}
        </ul>

        <div className="mt-9 space-y-3 rounded-3xl bg-white px-6 py-6 text-center text-[18px] leading-relaxed" data-id="element-198" data-mp="2464lm3w3ulyk">
          <p className="font-bold text-ink" data-id="element-199" data-mp="293d7aeggp84k">{painClosing.lead}</p>
          {painClosing.lines.map(l => <p key={l} className="text-body" data-id="element-200" data-mp="1ueqi7l119205">
              {l}
            </p>)}
        </div>
      </div>
    </section>;
}